var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-videos"},[_c('LastListVideos',{key:"last-videos",staticClass:"container-videos__last",attrs:{"title":_vm.getTitle}}),_c('ListVideos',{key:"list-videos",staticClass:"container-videos__me",attrs:{"title":_vm.$t('containerVideos.myList')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }